import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getEvents } from '../redux/actions/events';
import { GET_EVENTS } from '../redux/constants';
import { requestFail, requestPending } from '../utils/status';

export const useGetEvents = ({ page = 1, search } = {}) => {
  const dispatch = useDispatch();
  const globalSelectedBuilding = useSelector(
    (state) => state.building.globalSelectedBuilding
  );
  const globalOrgId = useSelector((state) => state.Organization.globalOrgId);
  const { events, pagination, getEventsStatus } = useSelector((state) => state.events);

  const hasBuilding = Boolean(globalSelectedBuilding?.id);
  const isEventsEnabled = Boolean(
    hasBuilding && globalSelectedBuilding?.config?.enable_events
  );
  const orgId = globalSelectedBuilding?.org_id || globalOrgId;

  const refetch = useCallback(() => {
    if (!isEventsEnabled || !orgId) {
      return;
    }

    const params = {
      building: globalSelectedBuilding.id,
      org: orgId,
      page
    };

    if (search) {
      params.search = search;
    }

    dispatch(getEvents({ params }));
  }, [dispatch, globalSelectedBuilding?.id, isEventsEnabled, orgId, page, search]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    data: isEventsEnabled ? events || [] : [],
    totalCount: pagination?.total || 0,
    totalPages: pagination?.totalPages || 1,
    isLoading: getEventsStatus === requestPending(GET_EVENTS),
    error: getEventsStatus === requestFail(GET_EVENTS),
    refetch,
    hasBuilding,
    isEventsEnabled
  };
};

export default useGetEvents;
